module.exports = __webpack_public_path__ + "static/media/roar1.70ddcc24.mp3";